(function ($) {
  function scrollRevealIntoView(element) {
    var desktopMenuOffset = window.matchMedia && window.matchMedia('(min-width: 769px)').matches ? 152 : 0;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var target = element && element.jquery ? element.get(0) : element;
    var scrollTop;

    if (!target || !window.scrollTo) {
      return;
    }

    window.requestAnimationFrame(function () {
      scrollTop = window.pageYOffset + target.getBoundingClientRect().top - desktopMenuOffset;

      window.scrollTo({
        top: Math.max(scrollTop, 0),
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    });
  }

  function trackAnswerSubmission($instance, selectedAnswer, isCorrect) {
    var eventName = $.trim($instance.data('analytics-event') || 'knifejoy_game_answer_submitted');
    var gameName = $.trim($instance.data('analytics-game-name') || 'guess_the_glitch');
    var eventParams = {
      answer_text: selectedAnswer,
      is_correct: isCorrect,
      game_name: gameName,
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParams);
      return;
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(
        $.extend(
          {
            event: eventName,
          },
          eventParams
        )
      );
    }
  }

  function initKnifejoyGame() {
    var $game = $('[data-kjg-game]');

    if (!$game.length) {
      return;
    }

    $game.each(function () {
      var $instance = $(this);
      var correctAnswer = $.trim($instance.data('correct-answer') || '');
      var revealCode = $.trim($instance.data('reveal-code') || '');
      var selectionError = 'Choose an answer before submitting.';
      var resultIntroCorrect = 'You Got It';
      var resultIntroIncorrect = 'Nice Try But Not Quite';
      var resultBody = 'The image below highlights the glitch.';
      var $questionStep = $instance.find('[data-kjg-question-step]');
      var $resultStep = $instance.find('[data-kjg-result-step]');
      var $feedback = $instance.find('[data-kjg-feedback]');
      var $resultIntro = $instance.find('[data-kjg-result-intro]');
      var $resultBody = $instance.find('[data-kjg-result-body]');
      var $codeValue = $instance.find('[data-kjg-code-value]');
      var $answers = $instance.find('[data-kjg-answer]');
      var $submit = $instance.find('[data-kjg-submit]');
      var selectedAnswer = '';

      $answers.on('click', function () {
        var $selected = $(this);
        selectedAnswer = $.trim($selected.data('kjg-answer') || '');

        $answers.removeClass('is-selected').attr('aria-pressed', 'false');
        $selected.addClass('is-selected').attr('aria-pressed', 'true');
        $feedback.removeClass('is-error is-success').text('');
      });

      $submit.on('click', function () {
        var isCorrect;

        if (!selectedAnswer) {
          $feedback
            .removeClass('is-success')
            .addClass('is-error')
            .text(selectionError);
          return;
        }

        isCorrect = selectedAnswer === correctAnswer;
        trackAnswerSubmission($instance, selectedAnswer, isCorrect);
        $resultIntro.text(isCorrect ? resultIntroCorrect : resultIntroIncorrect);
        $resultBody.text(resultBody);
        $codeValue.text(revealCode);
        $questionStep.prop('hidden', true);
        $resultStep.prop('hidden', false);
        $feedback
          .removeClass('is-error is-success')
          .text('');
        scrollRevealIntoView($resultStep);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKnifejoyGame);
  } else {
    initKnifejoyGame();
  }
})(jQuery);
